import localforage from 'localforage'

// exported to be reused when setting/getting saved searches
export const AIR_SEARCH_DATA = 'AIR_SEARCH_DATA'
export const CAR_SEARCH_DATA = 'CAR_SEARCH_DATA'
export const HOTEL_SEARCH_DATA = 'HOTEL_SEARCH_DATA'
export const PACKAGE_SEARCH_DATA = 'PACKAGE_SEARCH_DATA'

export type PERSISTED_SEARCH_KEY =
  | typeof AIR_SEARCH_DATA
  | typeof CAR_SEARCH_DATA
  | typeof HOTEL_SEARCH_DATA
  | typeof PACKAGE_SEARCH_DATA

export type SavedSearch = {
  tripType: string
  timestamp?: number
  [key: string]: any
}

function isSavedSearch(
  item: SavedSearch | null | undefined
): item is SavedSearch {
  return item !== null && item !== undefined
}

function getPersistedSearchData(key: PERSISTED_SEARCH_KEY) {
  return localforage.getItem<SavedSearch[]>(key)
}

export async function getPersistedSearchDataByKeys(
  keys: Array<PERSISTED_SEARCH_KEY>,
  sort = false
) {
  const promiseResultsArray = await Promise.all(
    keys.map(getPersistedSearchData)
  )

  let results: SavedSearch[] = []

  try {
    results = promiseResultsArray.flat().filter(isSavedSearch)
  } catch {
    return []
  }

  // sort is by most recently saved
  if (sort) {
    return results.sort((a: SavedSearch, b: SavedSearch) => {
      if (a.timestamp && b.timestamp) {
        return b.timestamp - a.timestamp
      }
      return 0
    })
  }

  return results
}

export async function persistSearchData(
  key: PERSISTED_SEARCH_KEY,
  data: SavedSearch
) {
  const timestamp = Date.now()
  const recentSearch = { ...data, timestamp }
  try {
    const recentSearches = await getPersistedSearchData(key)
    return localforage.setItem(
      key,
      [recentSearch, recentSearches?.[0], recentSearches?.[1]].filter(Boolean)
    )
  } catch {
    return localforage.setItem(key, [recentSearch])
  }
}
